import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getFillingPersonStock,
  fillingPersonStockLogs,
  fillingPersonStockTransaction,
  getFillingPersonStockHistory,
} from "data/server_apis/inventoryService";

const fillingPersonStockAdapter = createEntityAdapter({
  selectId: (fillingPersonStock) => fillingPersonStock.id,
});

const fillingPersonStockLogAdapter = createEntityAdapter({
  selectId: (log) => log.id,
});

export const fillingPersonStockTransactionThunk = createAsyncThunk(
  "fillingPersonStock/create",
  async ({ stock, data }, { rejectWithValue }) => {
    try {
      return (await fillingPersonStockTransaction(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getFillingPersonStockLogsThunk = createAsyncThunk(
  "fillingPersonStockLogs/get",
  async ({ page, from_date, to_date, fillingPerson }, { rejectWithValue }) => {
    try {
      return (await fillingPersonStockLogs(page, from_date, to_date, fillingPerson))
        .data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getFillingPersonStockThunk = createAsyncThunk(
  "fillingPersonStock/get",
  async (fillingPerson, { rejectWithValue }) => {
    try {
      return (await getFillingPersonStock(fillingPerson)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getFillingPersonStockHistoryThunk = createAsyncThunk(
  "fillingPersonStockHistory/get",
  async ({time,fillingPerson}, { rejectWithValue }) => {
    try {
      return (await getFillingPersonStockHistory(time,fillingPerson)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const fillingPersonStockSlice = createSlice({
  name: "fillingPersonStack",
  initialState: fillingPersonStockAdapter.getInitialState({
    fillingPersonStockStatus: {},
    fillingPersonStockTransactionStatus: {},
    logs: fillingPersonStockLogAdapter.getInitialState(),
    logStatus: {},
    logPageCount: 1,
    history: [],
    historyStatus: {},
  }),
  reducers: {
    resetFillingPersonStockTransactionStatus : (state,action)=>{
      state.fillingPersonStockTransactionStatus = { };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fillingPersonStockTransactionThunk.pending, (state, action) => {
        state.fillingPersonStockTransactionStatus = { loading: "post" };
      })
      .addCase(fillingPersonStockTransactionThunk.rejected, (state, action) => {
        state.fillingPersonStockTransactionStatus = {
          error: "post",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(fillingPersonStockTransactionThunk.fulfilled, (state, action) => {
        state.fillingPersonStockTransactionStatus = {
          success: "post",
          errorMessage: action.payload?.message,
        };
        if (
          action.meta.arg.data.in_or_out === "ret" ||
          action.meta.arg.data.in_or_out === "out" || 
          action.meta.arg.data.in_or_out === "rem"
        ) {
          const stock = { ...action.meta.arg.stock };
          stock.qty -= action.payload.qty;
          fillingPersonStockAdapter.updateOne(state, {
            id: action.meta.arg.stock.id,
            changes: stock,
          });
        }
      });

    builder
      .addCase(getFillingPersonStockThunk.pending, (state, action) => {
        state.fillingPersonStockStatus = { loading: "get" };
      })
      .addCase(getFillingPersonStockThunk.rejected, (state, action) => {
        state.fillingPersonStockStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getFillingPersonStockThunk.fulfilled, (state, action) => {
        state.fillingPersonStockStatus = {
          success: "get",
        };
        fillingPersonStockAdapter.setAll(state, action.payload);
      });

    builder.addCase(getFillingPersonStockLogsThunk.fulfilled, (state, action) => {
      fillingPersonStockLogAdapter.setAll(state.logs, action.payload.results);
      state.logPageCount = action.payload.total_pages;
    });

    builder
      .addCase(getFillingPersonStockHistoryThunk.pending, (state, action) => {
        state.getMainStockHistory = { loading: "get" };
      })
      .addCase(getFillingPersonStockHistoryThunk.rejected, (state, action) => {
        state.getMainStockHistory = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getFillingPersonStockHistoryThunk.fulfilled, (state, action) => {
        state.getMainStockHistory = {
          success: "get",
        };
        state.history = action.payload;
      });
  },
});

export const {resetFillingPersonStockTransactionStatus} = fillingPersonStockSlice.actions;
export const fillingPersonStockSelector = fillingPersonStockAdapter.getSelectors(
  (state) => state.fillingPersonStock
);

export const fillingPersonStockLogSelector =
  fillingPersonStockLogAdapter.getSelectors(
    (state) => state.fillingPersonStock.logs
  );

export default fillingPersonStockSlice.reducer;
